var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 598,
    viewBox: "0 0 403 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bgrect",
    d: "M403 0H0V598H403V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-class1",
    id: "color2",
    d: "M0 0H403V308.5L350.5 298.5H294L144.5 250L78.5 152.5L27 125L0 104V0Z",
    fill: "#2C44E8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-class2",
    id: "color1",
    d: "M0 151V108V101.5H137L156 151L352 300L106 340L0 344.5V151Z",
    fill: "#EF84F1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-class3",
    id: "color3",
    d: "M254.5 118L331.5 94L403 85V318H347.5L221 207L254.5 118Z",
    fill: "#75D2DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bgrect",
    width: 403,
    height: 598,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.51b2737cb87a3ba1a131136e76e3d232.svg";
export { ForwardRef as ReactComponent };